import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("circle", {
  cx: 34,
  cy: 32,
  r: 26,
  fill: "#C1E5FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "#73C4FF"
});

var _ref3 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M26.296 32.928c0-.853.139-1.6.416-2.24.299-.661.65-1.216 1.056-1.664.427-.448.981-.981 1.664-1.6.853-.747 1.483-1.387 1.888-1.92.405-.555.608-1.216.608-1.984 0-1.045-.405-1.877-1.216-2.496-.81-.64-1.93-.96-3.36-.96-2.496 0-4.405.843-5.728 2.528l-2.336-1.664c.896-1.152 2.037-2.037 3.424-2.656 1.408-.619 3.03-.928 4.864-.928 2.325 0 4.17.512 5.536 1.536 1.365 1.003 2.048 2.39 2.048 4.16 0 .875-.15 1.653-.448 2.336-.277.661-.619 1.216-1.024 1.664-.405.448-.95.981-1.632 1.6-.875.79-1.525 1.483-1.952 2.08-.405.597-.608 1.333-.608 2.208h-3.2zm1.632 7.264c-.597 0-1.099-.192-1.504-.576a2.062 2.062 0 0 1-.576-1.472c0-.576.192-1.056.576-1.44.405-.405.907-.608 1.504-.608s1.088.203 1.472.608c.384.384.576.864.576 1.44s-.203 1.067-.608 1.472c-.384.384-.864.576-1.44.576z",
  fill: "#fff"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 60,
    height: 58,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/faq-can-take.662fc271.svg";
export { SvgComponent as ReactComponent };